;(function() {
  'use strict'

  Factory.$inject = ["WeightRule"];
  angular.module('app.core').factory('WeightScheme', Factory)

  /* @ngInject */
  function Factory(WeightRule) {
    function WeightScheme() {
      this.weightByRespondentId = {}
      this.applyDefaults()
    }

    WeightScheme.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        enabled: false,
        weightRules: [],
      })
    }

    WeightScheme.prototype.deserialize = function(data) {
      data = _.isPlainObject(data) ? data : {}

      this.enabled = data.enabled
      this.weightRules = (data.weightRules || []).map(function(item) {
        return new WeightRule().deserialize(item)
      })

      this.applyDefaults()
      return this
    }

    WeightScheme.prototype.serialize = function() {
      var data = {}
      data.enabled = this.enabled
      data.weightRules = this.weightRules.map(function(weightRule) {
        return weightRule.serialize()
      })
      return data
    }

    WeightScheme.prototype.clone = function() {
      return new WeightScheme().deserialize(this.serialize())
    }

    WeightScheme.prototype.copy = function(weightScheme) {
      this.deserialize(weightScheme.serialize())
    }

    WeightScheme.prototype.validate = function(filters) {
      var errors = []

      if (this.enabled) {
        if (!this.weightRules.length) {
          errors.push('Weight rules minimum 1')
        }
        _.each(this.weightRules, function(weightRule) {
          if (!weightRule.validate(filters)) {
            errors = _.concat(errors, weightRule.errors)
          }
        })
      }

      this.errors = errors.length ? errors : null
      return !errors.length
    }

    WeightScheme.prototype.apply = function(csv, datapack, filtersById) {
      this.weightByRespondentId = {} // clear the weights

      if (!this.enabled) return

      var self = this
      var idIdx = datapack.mappings.columns.id
      for (var row of csv) {
        _.each(this.weightRules, function(weightRule) {
          if (weightRule.match(row, filtersById)) {
            var respondentId = row[idIdx]
            self.weightByRespondentId[respondentId] = weightRule.weight
            return false // break
          }
        })
      }
    }

    WeightScheme.prototype.getWeight = function(respondentId) {
      var weight = this.weightByRespondentId[respondentId]
      return weight !== undefined ? weight : 1
    }

    WeightScheme.prototype.addWeightRule = function() {
      this.weightRules.push(new WeightRule())
    }

    WeightScheme.prototype.removeWeightRule = function(idx) {
      this.weightRules.splice(idx, 1)
    }

    WeightScheme.prototype.removeWeightRulesByFilterId = function(filterId) {
      _.remove(this.weightRules, function(weightRule) {
        return weightRule.filterId === filterId
      })
    }

    WeightScheme.prototype.getWeightsForExport = function() {
      return _.isEmpty(this.weightByRespondentId)
        ? null
        : _.cloneDeep(this.weightByRespondentId)
    }

    return WeightScheme
  }
})()
